import React, { useEffect, useState } from "react";
import { faCartShopping, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Cart.css";
import { Button } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import CartProductCard from "./cart_product_card/CartProductCard";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../features/cart/cartSlice";
import { appSetup } from "../../features/master/masterSlice";
import {
  getAllProducts,
  getAllProductsYouLike,
  getProduct,
} from "../../features/products/productsSlice";
import {
  OrderCalculation,
  getAllOrderAddress,
  getAllOrderAddressBilling,
} from "../../features/order/orderSlice";
import Common_Title from "../common_components/common_title/Common_Title";
import Black_Btn from "../common_components/common_btn/Black_Btn/Black_Btn";
import Light_Blue_Btn from "../common_components/common_btn/light_blue_btn/Light_Blue_Btn";
import Reccomndation from "../product_description/reccomndation/Reccomndation";
import { decodeId, variant_type } from "../../utils/common";
import Confirm_Delivery_Address_Offcanvas from "./confirm_delivery_address_offcanvas/Confirm_Delivery_Address_Offcanvas";
import Login_Modal from "../common_components/common_modal/login_flow/login_modal/Login_Modal";
import Reset_Password_Modal from "../common_components/common_modal/login_flow/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../common_components/common_modal/login_flow/set_new_password_modal/Set_New_Password_Modal";
import Special_Instructions_Modal from "../common_components/common_modal/Special_Instructions_Modal/Special_Instructions_Modal";

const Cart = ({ deliveryNote, setDeliveryNote }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const [showModal, setShowModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);

  const cart = useSelector((state) => state.cart.allCarts);

  const allAddress = useSelector((state) => state.order.allOrdersAddress);
  const allBillingAddress = useSelector(
    (state) => state.order.allBillingAddress,
  );

  const user = useSelector((state) => state.myaccount.addMyaccount);
  useEffect(() => {
    // if (user?.id) {
    dispatch(getAllOrderAddress());
    dispatch(getAllOrderAddressBilling());
    // }
  }, []);

  useEffect(() => {
    dispatch(getAllCart(isSignIn));
  }, []);

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, []);

  const [modalShow, setModalShow] = useState(false);

  // const saveTotal = (cart) => {
  //   let total = 0;
  //   let selling = 0;
  //   let mrp_data = 0;
  //   let selling_price = 0;
  //   let count = 0;
  //   let tax = 0;
  //   let cess = 0;

  //   if (cart?.data?.data?.length > 0) {
  //     for (const element of cart?.data?.data) {
  //       const taxPercentage = element?.Product?.tax_percentage ?? 0;
  //       const cessPercentage = element?.Product?.cess_percentage ?? 0;
  //       const taxper = Number(taxPercentage) + Number(cessPercentage);
  //       const qty = Number(element.quantity);
  //       const price = Number(
  //         element?.Product_Variant?.price / (1 + taxper / 100),
  //       ).toFixed(2);

  //       const mrp = Number(
  //         element?.Product_Variant?.mrp / (1 + taxper / 100),
  //       ).toFixed(2);

  //       const sellingprice = Number(element?.Product_Variant?.price).toFixed();
  //       const mrpdata = Number(element?.Product_Variant?.mrp).toFixed();

  //       selling_price += sellingprice * qty;
  //       mrp_data += mrpdata * qty;
  //       total += mrp * qty;
  //       tax +=
  //         (price * qty * Number(element?.Product?.tax_percentage || 0)) / 100;
  //       cess +=
  //         (price * qty * Number(element?.Product?.cess_percentage || 0)) / 100;
  //       selling += price * qty;
  //       count += 1;
  //       setTotalAmount(total);
  //       setTotalSaving(selling);
  //       setCount(count);
  //     }
  //   }
  //   const data = {
  //     total_mrp: Number(total).toFixed(2),
  //     total_mrp_gst: Number(mrp_data).toFixed(2),
  //     total_selling_price_gst: Number(selling_price).toFixed(2),
  //     total_tax: Number(tax).toFixed(2),
  //     no_of_item: count,
  //     total_cess: Number(cess).toFixed(2),
  //     total_selling_price: Number(selling).toFixed(2),
  //     total_amount: selling + tax + cess,
  //   };
  //   return data;
  // };
  const [data, setData] = useState();

  // useEffect(() => {
  //   const data = saveTotal(cart);
  //   setData(data);
  // }, [cart]);

  const [canProceed, setCanProceed] = useState("");

  useEffect(() => {
    if (cart?.data?.length > 0) {
      const hasUnavailable = cart?.data.some((val) => {
        let stock = 0;

        if (
          Number(val?.Product?.variant_type_id) === Number(variant_type.Single)
        ) {
          stock = Number(val?.Product_Variant?.general_stock ?? 0);
        } else if (
          Number(val?.Product?.variant_type_id) === Number(variant_type.Double)
        ) {
          stock = Number(val?.Double_Variant?.stock ?? 0);
        } else if (
          Number(val?.Product?.variant_type_id) === Number(variant_type.Triple)
        ) {
          stock = Number(val?.Triple_Variant?.stock ?? 0);
        }

        const quantity = Number(val?.quantity ?? 0);
        const isOutOfStock = stock < quantity;

        const isDeleted = val?.Product?.deletedAt !== null;

        return isOutOfStock || isDeleted;
      });

      if (hasUnavailable) {
        setCanProceed(
          "Some products in your cart are unavailable. Please update your cart before proceeding to payment.",
        );
      } else {
        setCanProceed("");
      }
    } else {
      setCanProceed("");
    }
  }, [cart]);

  // const [paymentData, setPaymentData] = useState({});
  // const orderCalculation = async (addressId) => {
  //   const data = {
  //     // address_id: props?.addressId || fallbackAddressId,
  //   };

  //   const res = await dispatch(OrderCalculation(data));

  //   if (res.meta?.requestStatus === "fulfilled") {
  //     setPaymentData(res?.payload?.data);
  //   } else if (res.meta?.requestStatus === "rejected") {
  //     // handle error
  //   }
  // };

  // useEffect(() => {
  //   orderCalculation();
  // }, []);

  const product = useSelector((state) => state.product.product);

  useEffect(() => {
    const deid = decodeId(cart?.data?.data?.[0]?.Product?.id);
    dispatch(getProduct(deid));
  }, [dispatch, data]);

  const You_May_Also_LikeProduct = useSelector(
    (state) => state.product.allProducts_you_like,
  );
  useEffect(() => {
    dispatch(
      getAllProductsYouLike({
        category_id: product?.p_category_id,
      }),
    );
  }, [dispatch, product]);

  return (
    <section className="Cart">
      <Breadcrumb_comp
        breadcrumbs={[
          { label: "Home", link: "/", isActive: false },
          { label: "Cart", link: "", isActive: true },
        ]}
        additionalClass="groceries "
      />

      <div className="cart_main_container">
        <div className="container ">
          <Common_Title title={"My Cart"} />

          <div className="data_holder">
            {cart?.data?.length > 0 ? (
              <div className="left_side_card">
                {cart?.data.map((item, index) => {
                  const mrp = Number(
                    item.Triple_Variant?.mrp * item?.quantity ||
                    item.Double_Variant?.mrp * item?.quantity ||
                    item.Product_Variant?.mrp * item?.quantity,
                  );

                  const price = Number(
                    item.Triple_Variant?.price * item?.quantity ||
                    item.Double_Variant?.price * item?.quantity ||
                    item.Product_Variant?.price * item?.quantity,
                  );

                  let stock;
                  if (
                    Number(item?.Product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    stock = Number(item?.Product_Variant?.general_stock);
                  } else if (
                    Number(item?.Product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    stock = Number(item?.Double_Variant?.stock);
                  } else if (
                    Number(item?.Product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    console.log(
                      Number(item?.Triple_Variant?.stock),
                      "Number(item?.Product_Variant?.general_stock)",
                    );

                    stock = Number(item?.Triple_Variant?.stock);
                  }
                  const isInstock = stock < item?.quantity;
                  return (
                    <div className="product_card_section" key={index}>
                      <CartProductCard
                        // title={item?.Product?.name}
                        // footer_text_color="#1f7041"
                        // img={item?.Product?.image}
                        // orderId="Order ID #675843"
                        // items="2 Items"
                        // kwd="Rs.: 200"
                        // footer_text="Delivering in 10 mins"
                        // date="27th Oct. | 03:28 pm"
                        // customClass={""}
                        cartVarient={item}
                        val={item}
                        mrp={mrp}
                        price={price}
                      // saveTotal={saveTotal}
                      />

                      {/* {(isDeleted || isOutOfStock) && ( */}
                      <div
                        style={{
                          color: "#a70808",
                          fontWeight: "bold",
                          marginTop: "5px",
                          marginBottom: "15px",
                          fontSize: "14px",
                          backgroundColor: "#ffe5e5",
                          padding: "5px",
                          borderRadius: "4px",
                        }}
                      >
                        {isInstock && (
                          <p className="text-danger mt-2">
                            Out of stock (Available: {stock})
                          </p>
                        )}
                        {/* ❌{" "}
                        {isDeleted
                          ? "This product is not available."
                          : "This product is out of stock."} */}
                      </div>
                      {/* )} */}
                    </div>
                  );
                })}

                <div className="row">

                  {isSignIn ? (
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-xl-6">
                          <div
                            className="delivery_note_div"
                            onClick={() => setModalShow(true)}
                          ><div className="">
                              <p className="delivery_note">
                                Delivery Note{" "}
                                <span className="inner">(Optional)</span>
                              </p>
                            </div>


                            <div className="plus_div">
                              <FontAwesomeIcon
                                icon={faPlus}
                                className="plus_icon"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div
                            className="delivery_note_div forgot"
                            onClick={() => setModalShow(true)}
                          >
                            <div className="">
                              <p className="delivery_note">Forgot Something?</p>
                            </div>

                            <div className="btn_holder">
                              <Black_Btn
                                btnText={"+ Add items"}
                                onClick={() => {
                                  navigate("/categories");
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : <div className="col-lg-6">

                  </div>}
                  <div className="col-lg-6">
                    <div className="last_price_div">
                      <div className="blue_div">
                        <p className="left_text">Cart Total</p>
                        <p className="left_text">
                          ₹{" "}
                          {Number(
                            cart?.data?.reduce(
                              (acc, item) =>
                                acc +
                                Number(item.Triple_Variant?.price) *
                                Number(item?.quantity) ||
                                Number(item.Double_Variant?.price) *
                                Number(item?.quantity) ||
                                Number(item.Product_Variant?.price) *
                                Number(item?.quantity) ||
                                0,
                              0,
                            ),
                          ).toFixed(2)}
                        </p>
                      </div>

                      <div className="bottom_div">
                        <p className="note_text">
                          Tax included & shipping calculated at checkout.
                        </p>

                        <div className="checkout_btn">
                          {canProceed ? (
                            <>
                              {" "}
                              <Light_Blue_Btn btnText="Proceed to Checkout" />
                              {canProceed && (
                                <div
                                  style={{
                                    color: "#a70808",
                                    marginTop: "10px",
                                    fontWeight: "bold",
                                    fontSize: "13px",
                                  }}
                                >
                                  {canProceed}
                                </div>
                              )}
                            </>
                          ) : (
                            <Light_Blue_Btn
                              btnText="Proceed to Checkout"
                              onClick={() => {
                                isSignIn
                                  ? setShowModal(true)
                                  : setShowLoginModal(true);
                              }}
                            />
                          )}
                        </div>

                        {/* <div className="checkout_btn">
                          <Light_Blue_Btn
                            btnText="Proceed to Checkout"
                            onClick={() => {
                              navigate("/checkout");
                            }}
                          />
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="empty_cart"
                style={{
                  textAlign: "center",
                  padding: "20px",
                  fontWeight: "bold",
                  fontSize: "40px",
                }}
              >
                🛒
                <p style={{ fontSize: "20px", margin: "10px 0 0" }}>
                  Your cart is empty
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Reccomndation product={You_May_Also_LikeProduct?.data} />

      <Confirm_Delivery_Address_Offcanvas
        setShowModal={setShowModal}
        showModal={showModal}
        allAddress={allAddress}
        allBillingAddress={allBillingAddress}
      />

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        loginDone={() => {
          setIsLogedIn(true);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
      />

      <Special_Instructions_Modal
        deliveryNote={deliveryNote}
        setDeliveryNote={setDeliveryNote}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Cart;
